import { useAuth } from "../Contexts/AuthContext";
import warningGeneral from "../assets/warningGeneral.png";
import Button from "../Components/Button";
import { Modal } from "@mui/material";
import React from "react";

function LogoutModal() {
  const { showLogoutModal, setShowLogoutModal, setLogoutReason, logoutReason } = useAuth();

  const handleLoginAgain = () => {
    setShowLogoutModal(false);
    setLogoutReason("");
  };

  return (
    <Modal
      open={showLogoutModal}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <div className="flex items-center justify-center mb-3">
          <img src={warningGeneral} width="60px" alt="warning icon" />
        </div>
        <div className="text-center font-semibold mb-1">
          You've been logged out!
        </div>
        <div className="text-center">
          You've been logged out of the app due to {logoutReason}.
        </div>
        <div className="mt-3">
          <Button className="w-full text-white" onClick={handleLoginAgain}>
            Ok
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default LogoutModal;
